module.exports = __webpack_public_path__ + "img/ring_g_e_1_1.05762912.png";